import React from 'react';

import {CircularLoader, Colors} from '@optimaxdev/design-system';
import classNames from 'classnames';

import {PaymentMoneyBackGuaranteeConnected} from '../../../paymentMoneyBackGuarantee/paymentMoneyBackGuarantee';

import {PaymentStepAgreement} from '../../../paymentStepAgreement/paymentStepAgreement';

import s from './paymentFooterWrapper.scss';

export type PropsType = {
    label?: string;
    children?: React.ReactNode;
    isLoading: boolean;
};

/**
 * One step checkout native payment method footer wrapper
 */
export const PaymentFooterWrapper = ({children = null, isLoading, label = ''}: PropsType) => {
    return (
        <div className={s.paymentFooter}>
            <div className={s.container}>
                {isLoading && (
                    <div className={s.loadingBlock}>
                        <CircularLoader color={Colors.codGray} size={32} />
                    </div>
                )}
                <div className={classNames(s.buttonContainer, {[s.hide]: isLoading})}>
                    {children}
                </div>

                <PaymentMoneyBackGuaranteeConnected />
                <p className={classNames(s.text, s.margin)}>
                    {!isLoading &&
                        `Click the button to be redirected to ${label} & complete your purchase.`}
                    <PaymentStepAgreement className={s.text} />
                </p>
            </div>
        </div>
    );
};
